<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item :link="{
          name: 'Dashboard',
          icon: 'ni ni ni-chart-bar-32 text-red',
          path: '/dashboard'
        }">
        </sidebar-item>

        <!-- <sidebar-item :link="{
          name: 'Virtual Insurance Broking Services',
          icon: 'ni ni ni ni-building text-red',
          collapsed: true
        }">
          <sidebar-item v-for="(product, index) in yiProducts.filter(f => f.Product_name != 'Property')" :key="index"
            v-if="isShowMenu(product)" :link="{
              name: product.Product_name,
              // icon: 'ni ni ni ni-building text-red',
              // collapsed: true 
            }">
            <sidebar-item v-if="!isCurrentPageCreateQuote(`products/${product.Url_slug}`)" :link="{
              name: 'Create Quote',
              icon: 'ni ni ni-single-copy-04 text-red',
              path: `/products/${product.Url_slug}/createQuote`
            }">
            </sidebar-item>

            <a v-if="isCurrentPageCreateQuote(`products/${product.Url_slug}`)"
              :href="`/products/${product.Url_slug}/createQuote`" aria-current="page"
              class="nav-link router-link-exact-active router-link-active"><span class="nav-link-text">Create Quote</span>
            </a>

            <sidebar-item :link="{
              name: 'Quotes',
              icon: 'ni ni ni-collection text-red',
              path: `/products/${product.Url_slug}/quotes`
            }">
            </sidebar-item>
            <sidebar-item :link="{
              name: 'Policies',
              icon: 'ni ni ni-collection text-red',
              path: `/products/${product.Url_slug}/policies`
            }">
            </sidebar-item>
          </sidebar-item>


          <sidebar-item :link="{
            name: 'Support',
            icon: 'ni ni ni ni-support-16 text-red',
            path: '/products/support'
          }">
          </sidebar-item>
        </sidebar-item> -->
        <!-- <sidebar-item
          :link="{
            name: 'Property',
            icon: 'ni ni ni ni-building text-red',
            collapsed: true 
          }"
        > -->




        <sidebar-item v-for="(product, index) in yiProducts.filter(f => f.Product_name == 'Property')" :key="'prop_' + index"
          v-if="isShowMenu(product)" :link="{
            name: product.Product_name,
            icon: 'ni ni ni-shop text-red',
            // collapsed: true 
          }">
          <sidebar-item v-if="!isCurrentPageCreateQuote(`products/${product.Url_slug}`)" :link="{
            name: 'Create Quote',
            icon: 'ni ni ni-single-copy-04 text-red',
            path: `/products/${product.Url_slug}/createQuote`
          }">
          </sidebar-item>

          <a v-if="isCurrentPageCreateQuote(`products/${product.Url_slug}`)"
            :href="`/products/${product.Url_slug}/createQuote`" aria-current="page"
            class="nav-link router-link-exact-active router-link-active"><span class="nav-link-text">Create Quote</span>
          </a>

          <sidebar-item :link="{
            name: 'Quotes',
            icon: 'ni ni ni-collection text-red',
            path: `/products/${product.Url_slug}/quotes`
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: 'Policies',
            icon: 'ni ni ni-collection text-red',
            path: `/products/${product.Url_slug}/policies`
          }">
          </sidebar-item>
        </sidebar-item>

        <sidebar-item v-for="(product, index) in yiProducts.filter(f => f.Product_name == 'PE Live')" :key="'pel_' + index"
          v-if="isShowMenu(product)" :link="{
            name: product.Product_name,
            icon: 'ni ni ni-app text-red',
            // collapsed: true 
          }">
          <sidebar-item v-if="!isCurrentPageCreateQuote(`/${product.Url_slug}`)" :link="{
            name: 'Create Quote',
            icon: 'ni ni ni-single-copy-04 text-red',
            path: `/${product.Url_slug}/createQuote`
          }">
          </sidebar-item>

          <a v-if="isCurrentPageCreateQuote(`/${product.Url_slug}`)" :href="`/${product.Url_slug}/createQuote`"
            aria-current="page" class="nav-link router-link-exact-active router-link-active"><span
              class="nav-link-text">Create Quote</span>
          </a>

          <sidebar-item :link="{
            name: 'Quotes',
            icon: 'ni ni ni-collection text-red',
            path: `/${product.Url_slug}/quotes`
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: 'Policies',
            icon: 'ni ni ni-collection text-red',
            path: `/${product.Url_slug}/policies`
          }">
          </sidebar-item>
        </sidebar-item>

        <sidebar-item v-for="(product, index) in yiProducts.filter(f => f.Product_name == 'Plant & Equipment')"
          :key="'pe_' + index" v-if="isShowMenu(product)" :link="{
            name: product.Product_name,
            icon: 'ni ni ni-app text-red',
            // collapsed: true 
          }">
          <sidebar-item v-if="!isCurrentPageCreateQuote(`ps-live`)" :link="{
            name: 'Create Quote',
            icon: 'ni ni ni-single-copy-04 text-red',
            path: `/${product.Url_slug}/createQuote`
          }">
          </sidebar-item>

          <a v-if="isCurrentPageCreateQuote(`ps-live`)" :href="`/${product.Url_slug}/createQuote`" aria-current="page"
            class="nav-link router-link-exact-active router-link-active"><span class="nav-link-text">Create Quote</span>
          </a>

          <sidebar-item :link="{
            name: 'Quotes',
            icon: 'ni ni ni-collection text-red',
            path: `/${product.Url_slug}/quotes`
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: 'Policies',
            icon: 'ni ni ni-collection text-red',
            path: `/${product.Url_slug}/policies`
          }">
          </sidebar-item>
        </sidebar-item>

        <sidebar-item v-for="(product, index) in yiProducts.filter(f => f.Url_slug == 'motor-live')"
          :key="'ml_' + index" v-if="isShowMenu(product)" :link="{
            name: product.Product_name,
            icon: 'fas fa-car text-red',
            // collapsed: true 
          }">
          <sidebar-item v-if="!isCurrentPageCreateQuote(`motor-live`)" :link="{
            name: 'Create Quote',
            icon: 'ni ni ni-single-copy-04 text-red',
            path: `/${product.Url_slug}/createQuote`
          }">
          </sidebar-item>

          <a v-if="isCurrentPageCreateQuote(`motor-live`)" :href="`/${product.Url_slug}/createQuote`" aria-current="page"
            class="nav-link router-link-exact-active router-link-active"><span class="nav-link-text">Create Quote</span>
          </a>

          <sidebar-item :link="{
            name: 'Quotes',
            icon: 'ni ni ni-collection text-red',
            path: `/${product.Url_slug}/quotes`
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: 'Policies',
            icon: 'ni ni ni-collection text-red',
            path: `/${product.Url_slug}/policies`
          }">
          </sidebar-item>
        </sidebar-item>

        <!-- <sidebar-item v-for="(product, index) in yiProducts.filter(f => f.Product_name == 'Other Assets')" :key="index"
          v-if="isShowMenu(product)" :link="{
            name: product.Product_name,
            icon: 'ni ni ni-shop text-red',
            // collapsed: true 
          }">
          <sidebar-item v-if="!isCurrentPageCreateQuote(`products/${product.Url_slug}`)" :link="{
            name: 'Create Quote',
            icon: 'ni ni ni-single-copy-04 text-red',
            path: `/products/${product.Url_slug}/createQuote`
          }">
          </sidebar-item>

          <a v-if="isCurrentPageCreateQuote(`products/${product.Url_slug}`)"
            :href="`/products/${product.Url_slug}/createQuote`" aria-current="page"
            class="nav-link router-link-exact-active router-link-active"><span class="nav-link-text">Create Quote</span>
          </a>

          <sidebar-item :link="{
            name: 'Quotes',
            icon: 'ni ni ni-collection text-red',
            path: `/products/${product.Url_slug}/quotes`
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: 'Policies',
            icon: 'ni ni ni-collection text-red',
            path: `/products/${product.Url_slug}/policies`
          }">
          </sidebar-item>
        </sidebar-item> -->


        <!-- </sidebar-item> -->
        

        


        <sidebar-item :link="{
          name: 'Reports',
          icon: 'ni ni ni ni-chart-bar-32 text-red',
          path: '/reports/yourInsuranceReports'
        }">
        </sidebar-item>

        <sidebar-item v-if="showVideos" :link="{
          name: 'Help Videos',
          icon: 'ni ni-button-play text-red',
          path: '/videos'
        }">
        </sidebar-item>

        <!-- <sidebar-item :link="{
          name: 'Support',
            icon: 'ni ni ni ni-support-16 text-red',
            path: '/products/support'
          }">
        </sidebar-item> -->

        <sidebar-item v-if="brokerObj.Broker_super_admin" :link="{
          name: 'Admin',
          icon: 'ni ni ni-folder-17 text-red',
          collapsed: true
        }">
          <sidebar-item :link="{
            name: 'Insurance Brokers',
            path: '/admin/insuranceBrokers'
          }"></sidebar-item>
          <sidebar-item :link="{
            name: 'Finance Networks',
            path: '/admin/financeNetworks'
          }"></sidebar-item>
          <sidebar-item :link="{ name: 'Broker Organisations', path: '/admin/brokerOrgs' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Brokers', path: '/admin/brokers' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Customers', path: '/admin/customers' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Email Templates', path: '/admin/emailTemplates' }"></sidebar-item>
          <sidebar-item :link="{
            name: 'Content Templates',
            path: '/admin/contentTemplates'
          }"></sidebar-item>
        </sidebar-item>
      </template>

      <template slot="links-after">
        <hr class="my-3" />
      </template>

      <template slot="footer">
        <div v-if="connectors.length" class="connector-status">
          <component
            :is="item.href ? 'a' : 'div'"
            v-for="item in connectors"
            :key="item.key"
            class="connector-status-link"
            :href="item.href || undefined"
            :target="item.href ? '_blank' : undefined"
            :rel="item.href ? 'noopener noreferrer' : undefined"
            :title="item.label"
          >
            <span class="connector-dot" :class="'connector-dot-' + item.status"></span>
            <span class="connector-label">{{ item.label }}</span>
          </component>
        </div>
      </template>
    </side-bar>
    <div class="main-content">
      <div class="body-container">
        <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

        <div @click="$sidebar.displaySidebar(false)">
          <fade-transition :duration="200" origin="center top" mode="out-in">
            <!-- your content here -->
            <router-view></router-view>
          </fade-transition>
        </div>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";
import { GlobalStore } from "../globalStore";
import { accessMethods } from "../helpers/accessPermissions";
import { authMethods } from "../helpers/auth";
import { appFunctions } from "../helpers/appFunctions";

export default {
  name: "DashboardLayout",
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition
  },
  data() {
    return {
      can_see_claims: false,
      can_see_fleet: false,
      can_see_fleet_management: false,
      show_lc: false,
      show_rs: false,
      yiProducts: [],
      connectors: [],
      connectorTimer: null
    };
  },
  computed: {
    brokerObj() {
      console.log(GlobalStore.brokerObj);
      return GlobalStore.brokerObj;
    },
    showVideos() {
      return String(process.env.VUE_APP_SHOW_VIDEOS || "").toLowerCase() === "true";
    }
  },
  created() {
    this.$root.$refs.DashboardLayout = this;
  },
  methods: {
    async checkAccessPermission(permission) {
      var res = await accessMethods.checkAccessPermission(permission);
      return res.data;
    },
    canSeeRideShare() {

      return false;
      // if (GlobalStore.brokerObj.Broker_org_id == "brkOrg-0101") {
      //   return true;
      // } else {
      //   return false;
      // }
    },
    isCurrentPageCreateQuote(productType) {
      if (window.location.href.includes(`/${productType}/createQuote`)) {
        return true;
      } else {
        return false;
      }
    },
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
    async disableOrEnabledMenu() {

      const isInsuranceBroker = GlobalStore.brokerObj.parentOrg.is_insurance_broker;

      await authMethods.initAppInstance();
      this.show_lc = this.permissionEnabled(
        this.brokerObj.Show_lc,
        this.brokerObj.parentOrg.default_show_lc
      );
      this.show_rs = this.permissionEnabled(
        this.brokerObj.Show_rs,
        this.brokerObj.parentOrg.default_show_rs
      );

      if (isInsuranceBroker == false) {
        this.show_lc = false;
        this.show_rs = false;
      }
    },
    permissionEnabled(enableBroker, parentOrg) {
      let status = null;
      switch (enableBroker) {
        case true:
          status = true;
          break;
        case null:
          if (parentOrg) status = true;
          else status = false;
          break;
        case false:
          status = false;
          break;
      }
      return status;
    },
    isShowMenu(product) {

      console.log(product);


      const isInsuranceBroker = GlobalStore.brokerObj.parentOrg.is_insurance_broker;

      // if (product.Product_code == "YIHQ-PSLIVE") {

      //   if (isInsuranceBroker == false) {
      //     return true;
      //   } else {
      //     return true;
      //   }
      // } else if (product.Product_code == "YIHQ-MOTORLIVE") {

      //   if (isInsuranceBroker == false) {
      //     return true;
      //   } else {
      //     return true;
      //   }
      // }
      // else {

        if (product.Visible_to_broker_orgs.length > 0) {
          const brokerOrgs = product.Visible_to_broker_orgs.find(item => item === this.brokerObj.parentOrg.Broker_org_id)


          if (brokerOrgs) {
            return true
          } else {
            // check special brokers that not in finance org but still see vibs products




            if (product.Visible_to_brokers.length > 0) {
              const broker = product.Visible_to_brokers.find(item => item === this.brokerObj.Broker_id)
              return broker ? true : false
            }



            return false
          }
        }

      //}
      // } else {
      //   // if (product.Visible_to_brokers.length > 0) {
      //   //     const broker = product.Visible_to_brokers.find(item => item === this.brokerObj.Broker_id)
      //   //     return broker ? true : false
      //   // }
      //   return true
      // }
    },
    async disableOrEnabledProduct() {
      await appFunctions
        .crud_yiProduct("getAllProducts", {})
        .then(resp => {
          this.yiProducts = resp.data;

          GlobalStore.yiProducts = resp.data;


        });
    },
    async loadConnectorStatus() {
      try {
        const resp = await appFunctions.listConnectorStatus();
        this.connectors = (resp && resp.connectors) || [];
      } catch (error) {
        console.error("Connector status request failed", error && error.message ? error.message : error);
        if (!this.connectors.length) {
          this.connectors = [];
        }
      }
    }
  },
  async mounted() {
    this.loadConnectorStatus();
    this.connectorTimer = setInterval(() => this.loadConnectorStatus(), 60000);
    this.initScrollbar();
    this.disableOrEnabledMenu();
    this.disableOrEnabledProduct();
    try {
      this.can_see_claims = await this.checkAccessPermission("can_see_claims");
      this.can_see_fleet = await this.checkAccessPermission("can_see_fleet");
      this.can_see_fleet_management = await this.checkAccessPermission(
        "can_see_fleet_management"
      );
    } catch (error) {
      console.error("Sidebar permissions failed", error);
    }
  },
  beforeDestroy() {
    if (this.connectorTimer) {
      clearInterval(this.connectorTimer);
    }
  }
};
</script>
<style lang="scss" scoped>
a.yi-red {
  color: #ff4438 !important;
}

.body-container {
  min-height: 91.5vh;
}
</style>
<style lang="scss">
.connector-status {
  flex: 0 0 auto;
  border-top: 1px solid #e9ecef;
  padding: 12px 16px 14px 8px;
  background: #fff;
}

.connector-status-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #525f7f;
  font-size: 12px;
  line-height: 1.2;
  text-decoration: none;
  margin-bottom: 8px;
}

.connector-status-link:last-child {
  margin-bottom: 0;
}

.connector-status-link:hover {
  color: #32325d;
  text-decoration: none;
}

.connector-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex: 0 0 auto;
  background: #adb5bd;
}

.connector-dot-up {
  background: #2dce89;
}

.connector-dot-recent {
  background: #ffc107;
}

.connector-dot-down {
  background: #f5365c;
}

.connector-dot-unknown {
  background: #adb5bd;
}

body.g-sidenav-hidden .connector-label {
  display: none;
}

body.g-sidenav-hidden .connector-status {
  padding-left: 0;
  padding-right: 0;
}

body.g-sidenav-hidden .connector-status-link {
  justify-content: center;
}
</style>
